import React, { useEffect, useRef, useState } from "react";
import { Col, Form, FormGroup, Button, Input, Label, Row } from "reactstrap";
import { debounce } from "underscore";

import {
  CardSwipe,
  luhnChecksum,
  parseCreditCards,
} from "../../../functions/Helper";
const CardInitial = {
  firstName: "",
  lastName: "",
  expirationYear: "",
  cardNumber: "",
  expirationMonth: "",
};
export default function Typesix() {
  const [flag, setflag] = useState(true);
  const [carddata, setCarddata] = useState(CardInitial);

  const CardHandle = (value) => {
    const { cardNumber, ...otherValues } = CardSwipe(value);
    if (luhnChecksum(cardNumber)) {
      setCarddata((carddata) => ({
        ...carddata,
        cardNumber,
        ...otherValues,
      }));
      return;
    }
    const parsedValues = parseCreditCards(value);
    if (parsedValues) {
      setCarddata((carddata) => ({
        ...carddata,
        ...parsedValues,
      }));
      return;
    }
    setCarddata((carddata) => ({
      ...carddata,
      cardNumber: value,
    }));
  };



  const FormSubmit = (e) => {
    e.preventDefault();
  };

 

  const CardValueHandle = (e) => {
    const { name, value } = e.target;
    setCarddata((carddata) => ({ ...carddata, [name]: value }));
  };

  const delayedQuery = useRef(
    debounce((carddata) => {
      if (carddata.cardNumber) {
        setflag(false);
      }
      CardHandle(carddata.cardNumber);
    }, 1000)
  ).current;

  const Reset = () => {
    setflag(true);
    setCarddata(CardInitial);
  };
  useEffect(() => {
    delayedQuery(carddata);
  }, [carddata]);

  return (
    <div>
      <Row>
        <Col sm="12" md={{ size: 5 }} className="mr-auto ml-auto">
          <div className="pmt-info-form">
            {/* <p>Add payment card</p> */}
            <Form onSubmit={FormSubmit}>
              {flag ? (
                <>
                  <Label for="Card Number">Card Number</Label>
                  <Input
                    type="text"
                    name="cardNumber"
                    value={carddata.cardNumber}
                    placeholder={"Please Swipe"}
                    onChange={CardValueHandle}
                  />
                </>
              ) : (
                <>
                  <Input
                    type="text"
                    name="cardNumber"
                    disabled={true}
                    value={carddata.cardNumber}
                    placeholder={"Please Swipe"}
                    onChange={CardValueHandle}
                  />
                  <FormGroup>
                    <Label for="Card Number">Card Number</Label>
                    ************{carddata.cardNumber.slice(12, 16)}
                  </FormGroup>
                  <Row form>
                    <Col>
                      <FormGroup>
                        <Label for="Card Number"> Name :</Label>
                        {carddata.firstName + " " + carddata.lastName}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form>
                    <Col lg="6" xl="4">
                      <FormGroup>
                        <Label for="Expiration">Expiry month</Label>
                        {carddata.expirationMonth}
                      </FormGroup>
                    </Col>
                    <Col lg="6" xl="4">
                      <FormGroup>
                        <Label for="Expiration">Year</Label>
                        {carddata.expirationYear}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button color="danger" onClick={Reset}>
                    {" "}
                    Swipe Again{" "}
                  </Button>
                </>
              )}
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
}
